import { styled, css } from 'styled-components'
import { onMediumScreen } from 'mixtiles-web-common'
import {
  TOP_BAR_DESKTOP_H_PADDING,
  TOP_BAR_DESKTOP_HEIGHT,
  TOP_BAR_MOBILE_H_PADDING,
} from './consts'

export const HeaderContainer = styled.header<{
  $sticky?: boolean
  $noBorder?: boolean
  $hidden?: boolean
  $topContentAvailable: boolean
  $absolute?: boolean
  $background?: string
}>`
  position: relative;
  border-bottom: ${(props) => (props.$noBorder ? 0 : 1)}px solid
    ${(props) => props.theme.colors.grayMedium};
  z-index: 100;

  ${(props) =>
    props.$sticky &&
    css`
      position: sticky;
      top: 0;
    `}

  transition: opacity 0.2s ease-in-out;

  background: ${(props) =>
    props.$background || props.theme.colors.grayBackgroundWhite};

  ${({ $hidden }) =>
    $hidden === true &&
    css`
      opacity: 0;
      transition-delay: 0s;
      pointer-events: none;
    `}

  ${({ $hidden }) =>
    $hidden === false &&
    css`
      opacity: 1;
      transition-delay: 0.3s;
    `}

  ${({ $absolute }) =>
    $absolute &&
    css`
      box-sizing: border-box;
      position: absolute;
      width: 100%;
    `}
`

export const MenuStrip = styled.div<{
  $topContentAvailable: boolean
  $background?: string
  $hasRoundedTopCorners?: boolean
}>`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;

  padding: 0 ${TOP_BAR_MOBILE_H_PADDING}px;

  ${onMediumScreen()} {
    height: ${TOP_BAR_DESKTOP_HEIGHT}px;
    padding: 0 ${TOP_BAR_DESKTOP_H_PADDING}px;
  }

  ${({ $topContentAvailable, $background }) =>
    $topContentAvailable &&
    $background !== 'transparent' &&
    css`
      box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.01);
      border-top: 1px solid ${({ theme }) => theme.colors.grayMedium};
      ${onMediumScreen()} {
        box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.03);
      }
    `}

  ${({ $hasRoundedTopCorners }) =>
    $hasRoundedTopCorners &&
    css`
      background: ${({ theme }) => theme.colors.white};
      border-radius: 16px 16px 0px 0px;
      ${onMediumScreen()} {
        border-radius: 20px 20px 0px 0px;
      }
    `}
`

export const ButtonContainer = styled.div``

export const TitleContent = styled.div`
  width: 160px;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  justify-content: center;
`
